import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Wrapper from '../layouts/Wrapper';
import { getPrivacyPolicy } from '../store/actions/privacyPage';
import Spinner from '../components/Spinner';

function PrivacyPolicy() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { loading, data } = useSelector((state) => state.privacyPage);
  useEffect(() => {
    dispatch(getPrivacyPolicy());
  }, []);
  return (
    <Wrapper>
      {(!loading) ? (
        <div className="container small">
          <div className="privacy-top">
            <p className="privacy-title">
              {/* {data.privacyPolicy.title[lang]} */}
            </p>
            <p className="privacy-text" dangerouslySetInnerHTML={{ __html: data.data.data.body[lang] }} />
          </div>
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default PrivacyPolicy;
